import { concat } from 'lodash';
import { Routes } from 'types/Routes';
import { menuEntries as chartMenuEntries } from './chart';
import { menuEntries as songsMenuEntries } from './songs';
import { menuEntries as stationMonitorsMenuEntries } from './station-monitors';

export const menuEntries: Routes[] = concat(chartMenuEntries, songsMenuEntries, stationMonitorsMenuEntries);
